import type { ValidationActionMessages } from './types';

export const DUPLICATE_ACTIONS = ['duplicate_and_add_to_name', 'duplicate_parent_adset'];
export const SUB_ACTIONS: Record<string, string[]> = {
  duplicate_and_add_to_name: ['set_budget', 'set_adset_budget'],
  duplicate_parent_adset: ['set_parent_adset_budget'],
};
export const SINGLE_ACTIONS = [
  'pause',
  'start',
  'notify',
  'remove_datetime_from_name',
  'ad_winner',
  'join_days_in_name',
  'auto_localization',
];
export const REST_ACTIONS = [
  'set_budget',
  'increase_budget',
  'decrease_budget',
  'increase_bid',
  'decrease_bid',
  'increase_roas',
  'decrease_roas',
  'q',
];
export const REPLACE_ACTIONS = ['replace_in_name'];
export const STRING_ACTIONS = ['add_to_name', 'remove_from_name'];
export const FLOW_CONSTANT_METRICS = ['flow', 'constant'];
export const COUNT_METRICS = ['active_ads_count', 'active_adsets_count'];

export const EXLUDED_ACTIONS = [
  'increase_adset_budget',
  'decrease_adset_budget',
  'set_parent_adset_budget',
  'set_adset_budget',
];

export const WEEK_DAY_VALUES = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const MULTIPLE_FILTER_OPERATORS = ['IN', 'NOT_IN'];

// Doc at the following link https://welltech.atlassian.net/wiki/spaces/MA1/pages/5104893981/Tech+Rule+builder#Validation-and-UI-messages-for-actions
export const VALIDATION_ACTION_MESSAGES: ValidationActionMessages = {
  add_to_name: {
    placeholder: 'Text to be added to name',
    error: 'Can’t be empty.',
  },
  remove_from_name: {
    placeholder: 'Text to be removed from name',
    error: 'Can’t be empty.',
  },
  increase_bid: {
    placeholder: '',
    error: 'Can’t be empty.',
  },
  decrease_bid: {
    placeholder: '',
    error: 'Can’t be empty.',
  },
  increase_budget: {
    placeholder: '',
    error: 'Can’t be empty.',
  },
  decrease_budget: {
    placeholder: '',
    error: 'Can’t be empty.',
  },
  increase_roas: {
    placeholder: '',
    error: 'Can’t be empty.',
  },
  decrease_roas: {
    placeholder: '',
    error: 'Can’t be empty.',
  },
  count: {
    placeholder: 'Value',
    error: '',
  },
  duplicate_parent_adset: {
    placeholder: 'Text to be added to name',
    error: 'Can’t be empty.',
  },
  duplicate_and_add_to_name: {
    placeholder: 'Text to be added to name',
    error: 'Can’t be empty.',
  },
  replace_in_name: {
    value: {
      placeholder: 'Find',
      error: 'Only latin letters, numbers and “_”, lowercase.',
    },
    second_value: {
      placeholder: 'Replace with',
      error: 'Can contain only lowercase latin letters, numbers and “_”.',
    },
  },
};
